import type { Api } from '@cocoonspace/types/shared/api'
import type { AxiosInstance, AxiosRequestConfig } from 'axios'

import { defineEndpoint } from '../utils/define-endpoint'

export interface UpdateEventGuests {
	uriParams: Api.Operations['updateEventGuests']['parameters']['path']
	body: NonNullable<
		Api.Operations['updateEventGuests']['requestBody']
	>['content']['application/json']
	response: Api.Operations['updateEventGuests']['responses']['202']
}

export const updateEventGuests = (
	axiosInstance: AxiosInstance,
	overideConfig?: AxiosRequestConfig,
) =>
	defineEndpoint<UpdateEventGuests>(
		{
			method: 'put',
			url: '/events/{eventId}/guests',
			...overideConfig,
		},
		axiosInstance,
	)
